/**
 * Compare two semver strings (major.minor.patch).
 * Returns -1 if a < b, 0 if equal, 1 if a > b.
 */
export function compareSemver(a, b) {
  const pa = a.split('.').map(Number)
  const pb = b.split('.').map(Number)
  for (let i = 0; i < 3; i++) {
    const av = pa[i] || 0
    const bv = pb[i] || 0
    if (av < bv) return -1
    if (av > bv) return 1
  }
  return 0
}

/**
 * Returns true if `current` is older than `minimum`.
 */
export function isVersionOutdated(current, minimum) {
  return compareSemver(current, minimum) < 0
}
